import React from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import CookieBanner from "./CookieBanner";
import Breadcrumbs from "./Breadcrumbs";

const GLASS_CANVAS_PATHS = new Set(["/about", "/privacy-policy"]);

function isGlassPage(pathname) {
    return GLASS_CANVAS_PATHS.has(pathname)
        || /^\/blog(?:\/[a-z0-9-]+)?$/.test(pathname)
        || /^\/fishes(?:\/[a-z0-9-]+)?$/.test(pathname)
        || /^\/tools/.test(pathname)
        || /^\/profile/.test(pathname)
        || /^\/spots\/new$/.test(pathname)
        || /^\/spots\/\d+(?:\/edit-suggestion)?$/.test(pathname)
        || /^\/forgot$/.test(pathname)
        || /^\/login$/.test(pathname)
        || /^\/register$/.test(pathname)
        || /^\/reset$/.test(pathname)
        || /^\/verify-email$/.test(pathname)
        || pathname === "/map";
}

export default function Layout({ children }) {
    const { pathname } = useLocation();
    const isGlass = isGlassPage(pathname);

    return (
        <div className="site-root">
            <Header />
            <main className={`main-container${isGlass ? " main-container--glass" : ""}`}>
                <Breadcrumbs />
                {children}
            </main>
            <Footer />
            <CookieBanner />
        </div>
    );
}